import {
  getBackgroundStyles,
  normalizeBackgroundPersistenceValue,
  resolveBackgroundPreset
} from './presetTemplates';

const imageBackgroundStyle = (imageUrl, fallbackColor) => ({
  backgroundImage: `url(${imageUrl})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundColor: fallbackColor
});

export const resolveTitleCardImageSource = (value) => {
  const normalized = normalizeBackgroundPersistenceValue(value || '');
  if (!normalized) return null;

  const resolved = resolveBackgroundPreset(normalized);
  if (!resolved) return null;

  if (resolved.type === 'image' && typeof resolved.value === 'string' && resolved.value.trim()) {
    return {
      value: resolved.value,
      presetId: resolved.id || '',
      fallbackColor: resolved.backgroundColor || ''
    };
  }

  return null;
};

const normalizeDeckBackgroundInput = (deckTitleCardBackground) => {
  if (!deckTitleCardBackground || typeof deckTitleCardBackground !== 'object') {
    return {
      imageValue: deckTitleCardBackground || '',
      fallbackColor: ''
    };
  }

  return {
    imageValue: deckTitleCardBackground.image || deckTitleCardBackground.value || '',
    fallbackColor: deckTitleCardBackground.color || deckTitleCardBackground.backgroundColor || ''
  };
};

export const resolveEffectiveTitleCardBackground = ({
  cardBackgroundImage,
  deckTitleCardBackground,
  fallbackColor = '#545f7d'
}) => {
  const perCardImage = resolveTitleCardImageSource(cardBackgroundImage);
  if (perCardImage?.value) {
    return {
      backgroundImage: perCardImage.value,
      backgroundColor: perCardImage.fallbackColor || fallbackColor,
      source: 'card-selected'
    };
  }

  const { imageValue: deckImageValue, fallbackColor: deckFallbackColor } = normalizeDeckBackgroundInput(deckTitleCardBackground);
  const deckImage = resolveTitleCardImageSource(deckImageValue);
  if (deckImage?.value) {
    return {
      backgroundImage: deckImage.value,
      backgroundColor: deckImage.fallbackColor || deckFallbackColor || fallbackColor,
      source: 'deck-default'
    };
  }

  return {
    backgroundImage: null,
    backgroundColor: deckFallbackColor || fallbackColor,
    source: 'color-fallback'
  };
};

export const resolveTitleCardBackgroundStyles = ({
  cardBackgroundImage,
  deckTitleCardBackground,
  fallbackColor = '#545f7d'
}) => {
  const effective = resolveEffectiveTitleCardBackground({
    cardBackgroundImage,
    deckTitleCardBackground,
    fallbackColor
  });

  if (effective.backgroundImage) {
    return imageBackgroundStyle(effective.backgroundImage, effective.backgroundColor || fallbackColor);
  }

  const { imageValue: deckImageValue, fallbackColor: deckFallbackColor } = normalizeDeckBackgroundInput(deckTitleCardBackground);
  const normalizedDeckBackground = normalizeBackgroundPersistenceValue(deckImageValue || '');
  if (normalizedDeckBackground) {
    const deckPreset = resolveBackgroundPreset(normalizedDeckBackground);
    if (deckPreset) {
      const styles = getBackgroundStyles(deckPreset);
      return {
        ...styles,
        backgroundColor: styles.backgroundColor || deckFallbackColor || fallbackColor
      };
    }
  }

  return { backgroundColor: deckFallbackColor || fallbackColor };
};
